import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { APP_LABELS } from '@config/app-config';
import CustomModal from '@utilities/CustomModal';

import Expenses from './expenses';
import Revenue from './revenue';

const CampFinancialsTab = props => {
  const { setLoader, status } = props;

  const [activeTab, setActiveTab] = useState('Revenue');
  const [showPopup, setShowPopup] = useState(false);
  const [currentTab, setCurrentTab] = useState('');
  const [lastActiveTab, setLastActiveTab] = useState('');

  const onActive = value => {
    if (value !== activeTab && sessionStorage.getItem('dirty') === 'true') {
      setShowPopup(true);
    } else {
      setActiveTab(value);
    }
    setCurrentTab(value);
    setLastActiveTab(activeTab);
  };

  const handleOk = () => {
    setActiveTab(currentTab);
    setShowPopup(false);
  };

  const handleCancel = () => {
    const activetab = lastActiveTab;
    document.getElementById(activetab).click();
    setActiveTab(activetab);
    setShowPopup(false);
  };

  return (
    <div>
      <div className="ymca-completeBox">
        <div className="ymca-directorInfo ymca-globalMetrics">
          <ul className="nav nav-tabs ymca-navTabs" id="myTab">
            <li className="nav-item ymca-navItems">
              <button
                className="nav-link ymca-navLinks active"
                id="Revenue"
                data-bs-toggle="tab"
                data-bs-target="#revenue"
                type="button"
                role="tab"
                aria-controls="revenue"
                aria-selected="true"
                onClick={() => {
                  onActive('Revenue');
                }}
              >
                Revenue
              </button>
            </li>
            <li className="nav-item ymca-navItems">
              <button
                className="nav-link ymca-navLinks"
                id="Expenses"
                data-bs-toggle="tab"
                data-bs-target="#expenses"
                type="button"
                role="tab"
                aria-controls="expenses"
                aria-selected="false"
                onClick={() => {
                  onActive('Expenses');
                }}
              >
                Expenses
              </button>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane ymca-tabPaneInner fade show active"
              id="revenue"
              role="tabpanel"
              aria-labelledby="Revenue"
            >
              {activeTab === 'Revenue' && (
                <Revenue setLoader={setLoader} status={status} />
              )}
            </div>
            <div
              className="tab-pane ymca-tabPaneInner fade"
              id="expenses"
              role="tabpanel"
              aria-labelledby="Expenses"
            >
              {activeTab === 'Expenses' && (
                <Expenses setLoader={setLoader} status={status} />
              )}
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        show={showPopup}
        type={APP_LABELS.WARNING}
        message="You have some unsaved changes. If you leave before saving, your
                changes will be lost."
        submitButtonName="Ok"
        onSubmit={handleOk}
        cancelButtonName="Cancel"
        onCancel={handleCancel}
      />
    </div>
  );
};

CampFinancialsTab.propTypes = {
  setLoader: PropTypes.func.isRequired,
  status: PropTypes.objectOf(PropTypes.any).isRequired
};

export default CampFinancialsTab;
